<app-layout title="Tableau de bord" client="">
  <div class="ms-2 p-1 flex flex-row gap-1 items-center border border-gray-300 rounded-2xl w-62.5">
    <div>
      <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill="currentColor"
          d="M13.413 11.413Q14 10.825 14 10t-.587-1.412T12 8t-1.412.588T10 10t.588 1.413T12 12t1.413-.587M12 19.35q3.05-2.8 4.525-5.087T18 10.2q0-2.725-1.737-4.462T12 4T7.738 5.738T6 10.2q0 1.775 1.475 4.063T12 19.35M12 22q-4.025-3.425-6.012-6.362T4 10.2q0-3.75 2.413-5.975T12 2t5.588 2.225T20 10.2q0 2.5-1.987 5.438T12 22m0-12"
        />
      </svg>
    </div>
    <ng-select
      [items]="(clients$ | async) ?? []"
      placeholder="Selectionner un client"
      bindValue="_id"
      bindLabel="name"
      class="borderless-select w-62.5"
      (change)="onChangeClient($event)"
    >
    </ng-select>
  </div>
  <app-notification-list [count]="5" [clientUuid]="clientService.selectedClient() || null"></app-notification-list>

  <app-form-select></app-form-select>
</app-layout>
